import { motion } from "framer-motion";

const features = [
  {
    icon: "🔒",
    title: "End-to-End Encryption",
    desc: "Secure your documents with enterprise-grade encryption in transit and at rest.",
  },
  {
    icon: "🛡️",
    title: "Role-Based Access Control",
    desc: "Manage user permissions with precision using role-based access control.",
  },
  {
    icon: "🌍",
    title: "Data Residency Options",
    desc: "Choose where your data is stored with flexible regional deployment.",
  },
  {
    icon: "📜",
    title: "Compliance-Ready Architecture",
    desc: "Built to align with global standards like GDPR, ISO, and SOC 2.",
  },
  //   {
  //     icon: "⚡",
  //     title: "High Availability & Resilience",
  //     desc: "Ensure uninterrupted operations with resilient infrastructure.",
  //   },
];

export default function SecurityFeaturesGrid() {
  return (
    <section className="section-padding bg-secondary ">
      <div className="container-width">
        <motion.div
          className="grid gap-6 [grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {features.map((item, i) => (
            <motion.div
              key={i}
              className="group feature-card bg-white/90 border border-neutral-200 rounded-[4px] p-6 text-center transition-all duration-300 hover:shadow-lg hover:border-primary/40"
              whileHover={{ y: -4 }}
            >
              {/* ICON */}
              <div
                className="w-12 h-12 mx-auto mb-5 rounded-[4px] flex items-center justify-center text-xl text-white"
                // style={{
                //   background:
                //     "linear-gradient(135deg, #7aaec3, #8ec1d7, #00bdef)",
                // }}
              >
                {item.icon}
              </div>

              {/* TITLE */}
              <h3 className="text-sm md:text-base font-semibold text-neutral-950 mb-3">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="text-xs md:text-sm text-neutral-600 leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
